{
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.integrations-service-mcp-request-notification.message-template.in-app.admin-hub-notifications.heading.no-translate": [
    {
      "type": 0,
      "value": "MCP server request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "integrations-service.integrations-service-mcp-request-notification.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "MCP server request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for Android or iOS."
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for Android or iOS."
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ]
}